import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import messages from '../../../locale/messages';
import style from '../ScheduleForm/ScheduleForm.scss';
import { INSTUMENTAL_MUSIC_PROGRAM_CODE } from '../../../constants';
import {customisedIntlFormatMessage} from '../../../utils/helpers';

const ANIMATION_DURATION = 700;

export const ExpressedInterestSaturdaySundayStep = ({
  schoolNameButtonClasses,
  stepButtonClasses,
  program,
  intl,
  title,
  show,
  nextClicked,
  selectionChanged,
  selectedOption,
  alternateMessage,
}) => {
  const options = [
    { id: 'SAT', name: intl.formatMessage(messages.expressdInterestSaturdaySundayOptionSAT) },
    { id: 'SUN', name: intl.formatMessage(messages.expressdInterestSaturdaySundayOptionSUN) },
    { id: 'LUN', name: intl.formatMessage(messages.expressdInterestSaturdaySundayOptionLUN) },
    { id: 'NL', name: intl.formatMessage(messages.expressdInterestSaturdaySundayOptionNL) },
  ];
  const buttons = (
    <div className={style.scheduleFormProgressButtonWrapper}>
      <Button label={customisedIntlFormatMessage(intl, messages.generalStringNext)} onClick={nextClicked} />
    </div>
  );
  const bodyCopy =
    'Does your child have a religious observance that would prevent them from testing on a Saturday or Sunday?';
  return (
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={program.school.name} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            <div className={style.scheduleFormStepTitle}>
              <div>{program.school.name}</div>
              <div>
                <i className="icon-Star" /> {program.name}
              </div>
            </div>
          </button>
        </div>
      </div>
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={program.school.name} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            <div className={style.scheduleFormStepTitle}>
              <div>Accommodations</div>
            </div>
          </button>
        </div>
      </div>
      {program.code === INSTUMENTAL_MUSIC_PROGRAM_CODE && (
        <div className={style.scheduleFormStepContainer}>
          <div className={style.scheduleFormStepTitleContainer}>
            <button disabled aria-label={program.school.name} className={classNames(...schoolNameButtonClasses)}>
              <div className={style.scheduleFormStepButtonIcon}>
                <i className="icon-Check" />
              </div>
              <div className={style.scheduleFormStepTitle}>
                <div>Select Instrument(s)</div>
              </div>
            </button>
          </div>
        </div>
      )}
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled className={classNames(...stepButtonClasses)}>
            <span className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Pencil" />
            </span>
            <h2 className={style.scheduleFormStepTitleActive}>{title}</h2>
          </button>
        </div>
        <AnimateHeight duration={ANIMATION_DURATION} height={show ? 'auto' : 0} animateOpacity>
          <div className={style.scheduleFormStepWrapper}>
            <div className={style.scheduleFormStep}>
              {alternateMessage !== null && (
                <div>
                  <div>{alternateMessage}</div>
                  {buttons}
                </div>
              )}
              {alternateMessage === null && (
                <div>
                  <div>{bodyCopy}</div>
                  <br />
                  <div>
                    <div
                      className={classNames(
                        style.scheduleFormCheckboxes,
                        style.scheduleFormCheckboxesIndented,
                      )}
                    >
                      {options.map(option => {
                        const key = `saturdaySundayOption-${option.id}`;
                        return (
                          <Checkbox
                            key={key}
                            id={key}
                            value={option.id}
                            checked={option.id === selectedOption}
                            label={option.name}
                            onChange={selectionChanged}
                          />
                        );
                      })}
                    </div>
                    {buttons}
                  </div>
                </div>
              )}
            </div>
          </div>
        </AnimateHeight>
      </div>
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={program.school.name} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            <div className={style.scheduleFormStepTitle}>Register</div>
          </button>
        </div>
      </div>
    </div>
  );
};
ExpressedInterestSaturdaySundayStep.propTypes = {
  schoolNameButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  stepButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  program: PropTypes.shape({
    school: PropTypes.shape({
      name: PropTypes.string,
    }),
    name: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  intl: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  nextClicked: PropTypes.func.isRequired,
  selectionChanged: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
  alternateMessage: PropTypes.string.isRequired,
};

export default ExpressedInterestSaturdaySundayStep;
